<template>
    <div class="container-fluid mt-5">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Histórico de Estudios</h3>
                <p class="text-muted">Evolución de los valores de estudios a lo largo del tiempo.</p>
            </div>
            <div class="col-md-12 text-center">
                <div v-if="isLoading">
                    <vs-spinner color="rgb(59,222,200)" />
                </div>
                <div v-else>
                    <apexchart type="area" :options="chartOptions" :series="chartSeries" height="350" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "PacienteEstudios",
    components: {
        apexchart: VueApexCharts
    },
    props: {
        paciente_id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            chartOptions: {
                chart: {
                    type: "area",
                    zoom: {
                        enabled: true
                    }
                },
                xaxis: {
                    type: "datetime",
                    labels: {
                        formatter: function (value) {
                            const date = new Date(value);
                            return date.toLocaleDateString("es-MX", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric"
                            });
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: "Valor"
                    }
                },
                colors: [], // Colores dinámicos para las series
                stroke: {
                    curve: "smooth"
                },
                fill: {
                    type: "gradient",
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.5,
                        opacityTo: 0.1,
                        stops: [0, 90, 100]
                    }
                },
                tooltip: {
                    x: {
                        formatter: function (value) {
                            const date = new Date(value);
                            return date.toLocaleDateString("es-MX", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric"
                            });
                        }
                    }
                }
            },
            chartSeries: [],
            seriesColors: ["#59bfff", "#9353e5", "#34c38f", "#f46a6a", "#f1b44c"] // Colores predefinidos
        };
    },
    mounted() {
        this.fetchPacienteEstudios();
    },
    methods: {
        async fetchPacienteEstudios() {
            try {
                const response = await axios.get(`${API}/evolucion_estudios`, {
                    params: {
                        paciente_id: this.paciente_id
                    }
                });

                if (response.data.status === "success") {
                    const data = response.data.data;
                    const groupedData = this.groupByStudy(data);

                    this.chartSeries = Object.keys(groupedData).map((studyName, index) => ({
                        name: studyName,
                        data: groupedData[studyName].map(item => ({
                            x: item.fecha,
                            y: item.valor
                        }))
                    }));

                    // Asignar colores dinámicos a las series
                    this.chartOptions.colors = Object.keys(groupedData).map(
                        (_, index) => this.seriesColors[index % this.seriesColors.length]
                    );
                } else {
                    this.notify("error", "No se pudo obtener el histórico de estudios.");
                }
            } catch (error) {
                console.error(error);
                this.notify("error", `Error: ${error.response?.data?.message || error.message}`);
            } finally {
                this.isLoading = false;
            }
        },
        groupByStudy(data) {
            return data.reduce((acc, item) => {
                if (!acc[item.nombre]) {
                    acc[item.nombre] = [];
                }
                acc[item.nombre].push(item);
                return acc;
            }, {});
        }
    }
};
</script>

<style scoped>
.text-main-gradient {
    background: linear-gradient(to right, #59bfff, #9353e5);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
